import { render, staticRenderFns } from "./TheCrm.vue?vue&type=template&id=2bbe2ed4&"
import script from "./TheCrm.vue?vue&type=script&lang=js&"
export * from "./TheCrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports